<template>
  <div
    class="app-dialer-common-page"
    :class="{ 'only-content': !showHeader }"
  >
    <div
      v-if="showHeader"
      class="header"
    >
      <div
        class="icon-button is-mobile"
        :class="{ 'is-disabled': isDisabled }"
        data-action="go-back"
        @click="onGoBack"
      >
        <or-icon icon="arrow_back" />
      </div>

      <div class="title">
        {{ title }}
      </div>
    </div>

    <div class="content">
      <slot name="default" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';
import { OrIconV3 as OrIcon } from '@onereach/ui-components-25';

export default defineComponent({
  name: 'AppDialerCommonPage',
  components: {
    OrIcon,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    isDisabled: Boolean,
  },
  emits: ['go-back'],
  methods: {
    onGoBack(event: MouseEvent) {
      if (!this.isDisabled) {
        this.$emit('go-back', event);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;
@import '../../styles';

.app-dialer-common-page {
  @include app-dialer-page;

  display: flex;
  flex-direction: column;
  color: var(--or-c-on-background);
  background: var(--or-c-surface-1);

  &.only-content {
    margin-top: 1.5rem;
  }

  .header {
    display: flex;
    align-items: center;
    margin: 1.5rem;

    .icon-button {
      @include app-dialer-icon-button;
      margin-right: 1rem;

      ::v-deep .or-icon-v3 {
        color: inherit;
      }
    }

    .title {
      @include text-overflow;

      font-size: var(--fs-2);
      font-weight: 700;
      line-height: 1.5rem;
    }
  }

  .content {
    flex: 1 1 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
